import React from 'react';
import spinner from './svg/spinner.svg';

export default class Spinner extends React.Component {
  render() {
    return (
      <span className='spinner-container'>
        <img src={spinner} className='spinner' />
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Loader/index.js